import { useState } from "react";

/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";

import { Heading, Paragraph } from "../UI/Typoraphy";
import Rating from "../Rating";
import { mq } from "../responsive";
import Cart from "../../assets/cart.svg";

import { useHistory } from "react-router";

const ProductCard = ({ data }) => {
  const { title, price, location, rating, wished, image, slug } = data;
  const [isWished, setWished] = useState(wished);

  const history = useHistory();

  const _handleWishClick = (e) => {
    setWished((isWished) => !isWished);
    // Call API
  };

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const handleCardClick = () => history.push(`/detail/${slug}`);

  return (
    <div
      css={{
        width: "30rem",
        borderRadius: "2rem",
        boxShadow: "0 4px 16px rgba(50, 50, 50, 0.1)",
        position: "relative",
        overflow: "hidden",

        [mq.md]: {
          width: "45rem",
        },
      }}
      onClick={handleCardClick}
    >
      <span
        css={{
          position: "absolute",
          top: "2rem",
          right: "2rem",
          cursor: "pointer",
          zIndex: 1,
        }}
        onClick={_handleWishClick}
      >
        {isWished ? (
          <i
            className="fas fa-heart"
            style={{ fontSize: "3rem", color: "#ff794b" }}
          ></i>
        ) : (
          <i
            className="far fa-heart"
            style={{ fontSize: "3rem", color: "#ff794b" }}
          ></i>
        )}
      </span>
      <figure
        css={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          height: "37rem",
          position: "relative",

          "&:before": {
            content: `""`,
            position: "absolute",
            width: "100%",
            height: "100%",

            background:
              "linear-gradient(180deg, rgba(0,0,0,0.4) 0%, rgba(255,255,255,0) 40%)",
          },

          [mq.md]: {
            height: "24rem",
          },
        }}
      >
        <img
          src={image}
          alt={title}
          css={{
            height: "110%",

            [mq.md]: {
              width: "100%",
              height: "auto",
            },
          }}
        />
      </figure>

      <div
        css={{
          padding: "12px 16px",
          height: "13rem",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
      >
        <div
          css={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Heading level={3} style={{ fontWeight: 500, lineHeight: "3rem" }}>
            {title}
          </Heading>
          <Paragraph>{formatter.format(price)}</Paragraph>
        </div>
        <Paragraph type="quote">
          <i
            className="fas fa-map-marker-alt"
            style={{ marginRight: "1rem" }}
          ></i>
          {location}
        </Paragraph>
        <Rating rate={rating} />
        <img
          src={Cart}
          alt="add to cart"
          css={{
            position: "absolute",
            bottom: "12px",
            right: "16px",
            cursor: "pointer",
          }}
        />
      </div>
    </div>
  );
};

export default ProductCard;
